// CodeDetectedPopup.js - Modal shown when code is detected in chat input
// Prompts user to use the coding area instead

import React from 'react';

const CodeDetectedPopup = ({ 
  onClose, 
  onSendAnyway 
}) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      backdropFilter: 'blur(6px)',
      WebkitBackdropFilter: 'blur(6px)',
      zIndex: 2000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <div style={{
        backgroundColor: '#fff',
        borderRadius: '12px',
        padding: '24px',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        animation: 'fadeIn 0.2s ease-out'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <span style={{ fontSize: '32px', marginRight: '12px' }}>💻</span>
          <h3 style={{ margin: 0, color: '#1f2937', fontSize: '20px' }}>Code Detected!</h3>
        </div>
        <p style={{ color: '#4b5563', marginBottom: '20px', lineHeight: '1.6' }}>
          Please put your code in the <strong>Coding Area</strong> on the right side of the screen where you can run and test it.
        </p>
        <p style={{ color: '#6b7280', marginBottom: '24px', fontSize: '14px' }}>
          📝 Use the chat to discuss your approach with the tutor, and the Coding Area to write and execute your code.
        </p>
        <div style={{ 
          display: 'flex', 
          gap: '12px', 
          justifyContent: 'flex-end',
          borderTop: '1px solid #e5e7eb',
          paddingTop: '16px'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              backgroundColor: '#f3f4f6',
              color: '#374151',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            OK
          </button>
          <button
            onClick={onSendAnyway}
            style={{
              padding: '10px 20px',
              backgroundColor: '#3b82f6',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            ✉️ Send to Tutor
          </button>
        </div>
      </div>
    </div>
  );
};

export default CodeDetectedPopup;
